import React from 'react'
import { Button } from 'react-bootstrap'
import { Pencil } from 'react-bootstrap-icons'
import useClientLocation from '../../../hooks/use-client-location'
import useCurrentUser from '../../../hooks/use-current-user'

const LearningResourceCreateButton = () => {
    const { isAdmin } = useCurrentUser()
    const { endpoints, toEndpoint } = useClientLocation()

    if (!isAdmin) {
        return null
    }

    return (
        <Button
            title='Create new resource'
            variant='outline-primary'
            size='lg'
            onClick={() => toEndpoint(endpoints.LEARNING_RESOURCE, { resourceId: 'new' })}
        >
            ADD NEW RESOURCE
        </Button>
    )

}

export default LearningResourceCreateButton